import axios from 'axios';
import { useUserStore } from '@/framework/store/user';
export const baseApi =
    import.meta.env.VITE_APP_NODE_ENV == 'development' ? "/OpenApiPrefix/api" : '/api';

// export const uploadUrl = `${baseApi}/sany/mgmt/v1/cms/upload`// /sany/mgmt/v1/cms/upload
export const uploadUrl = "https://mgmt.sanytruck.com/vd/sanymgmt/sany/mgmt/v1/cms/upload"
export const getAllProvinceListHttpUrl=`${baseApi}/sany/area/getAllProvince` //获取所有省
export const getCityListHttpUrl=`${baseApi}/sany/area/getAllCity` //获取城市列表



export function httpPost(url, data) {
    return new Promise((resolve, reject) => {
        return axiosReq({
            url: url,
            method: 'post',
            data,
        }).then((res) => {
            resolve(res)
        }).catch((err) => {
            //console.log("网络异常:查询车队列表失败!");
            reject(err)
        });
    })
}

export function httpGet(url, data = {}, isParams = false) {
    // console.log("httpGet=> url:", url, " data:", data, " isParams:", isParams)
    return new Promise((resolve, reject) => {
        return axiosReq({
            url: url,
            method: 'get',
            isParams: isParams,
            data,
        }).then((res) => {
            resolve(res)
        }).catch((err) => {
            //console.log("网络异常:查询车队列表失败!");
            reject(err)
        });
    })
}


/**
 * 获取批量导入模板
 * @param {*} companyTruckId
 * @returns
 */
export function getBatchImportTemplate(params) {
    const { access_token, userInfo } = useUserStore();
    const myAxiosReq = axios.create({
        headers: {
            Authorization: `Bearer ${access_token}`,
            account_id: userInfo?.accountId
        }
    })
    return myAxiosReq
        .get(`${baseApi}/board/v1/mgmt/truck/downloadtruck?request_no = ${new Date().getTime()}`, {
            params,
            responseType: 'blob'
        })
        .then(({ headers, data }) => {
            let contentType = headers['content-type'];
            let fileName =
                decodeURI(
                    headers['content-disposition'].split('filename=')?.[1]
                ) || null;
            downloadFile(data, contentType, fileName);
        });
}

// 下载blob流文件
export const downloadFile = (res, type, fileName) => {
    console.log(res, type, fileName);
    const blob = new Blob([res], { type: type });
    const a = document.createElement('a');
    const URL = window.URL || window.webkitURL;
    const href = URL.createObjectURL(blob);

    a.href = href;
    a.download = fileName || Date.parse(new Date());
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(href);
};


 // 从响应中提取文件名
 export function extractFilename(res) {
    const header = res.headers['content-disposition'];
    const index = header.indexOf('filename=');
    // console.log("header:",header)
    const filename = header.substring(index + 9);
    // 当文件名中同时包含中文和其他符号时无法正确解析
    let str = '';
    try {
        // console.log("fileName:",filename)
        // 解析服务端ISO-8859-1编码的文件名
        // str = decodeURIComponent(escape(filename));
        str = decodeURIComponent(filename);
        // console.log("str:",str)
    } catch (e) {
        // console.log("错误信息：",e)
        str = filename;
    }

    return str;
}